import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            学历提升方式
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            四种正规途径，总有一种适合您
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-50 mb-5 group-hover:bg-accent-100 transition-colors">
                <i className={`${category.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{category.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                {category.description}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{category.articleCount} 篇相关文章</span>
                <span className="flex items-center gap-1 text-accent-600 group-hover:translate-x-1 transition-transform">
                  了解更多 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}